let store = require("../store");
let actions = require("../actions");

let RecordingCalendar = require("../widget/RecordingCalendar");
let SleepChart = require("../widget/SleepChart");
let PostureChart = require("../widget/PostureChart");
let StepChart = require("../widget/StepChart");
let MetricBrief = require("../widget/MetricBrief");
let MetricBullet = require("../widget/MetricBullet");
let MetricTimeline = require("../widget/MetricTimeline");

let IconButton = mc.widgets.IconButton;

class MetricDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { subjectId } = this.props;
    let state = store.getState();

    return {
      subject: state.subjects[subjectId],
      annotations: state.annotations[subjectId],
      metrics: state.metrics[subjectId],
      channels: state.channels
    };
  }

  componentDidMount() {
    let { studyId, subjectId, startTs } = this.props;
    let { subject } = this.state;

    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    this.loadSubject = subject ? Promise.resolve({ subject }) : actions.loadSubject(studyId, subjectId);

    this.loadData(+startTs);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.startTs !== this.props.startTs) {
      this.loadData(+this.props.startTs);
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  getBounds(startTs, tz) {
    let tzOffsetMillis = mc.tz.info(startTs, tz).offset;
    let channelStartTs = startTs - tzOffsetMillis - (12 * mc.math.MILLIS_PER_HOUR);
    let channelBreakTs = startTs - tzOffsetMillis;
    let channelStopTs = channelStartTs + (36 * mc.math.MILLIS_PER_HOUR);

    return {
      channelStartTs,
      channelBreakTs,
      channelStopTs
    };
  }

  loadData(startTs) {
    let { studyId, subjectId } = this.props;

    let metricStartTs = startTs - (mc.math.MILLIS_PER_DAY * 30);
    let metricStopTs = startTs + (mc.math.MILLIS_PER_DAY * 30);

    this.loadSubject.then((function (payload) {
      let bounds = this.getBounds(startTs, payload.subject.timezone);

      actions.loadMetrics(studyId, subjectId, metricStartTs, metricStopTs);
      actions.loadAnnotations(studyId, subjectId, bounds.channelStartTs, bounds.channelStopTs);
      actions.loadChannels(studyId, subjectId, bounds.channelStartTs, bounds.channelStopTs);
    }).bind(this));
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  getSeries(channelType, startTs, stopTs) {
    let { channels } = this.state;

    let channel = channels.find((c) => c.type === channelType);

    if (channel) {
      return channel.times.map(function (ts, i) {
        return { ts, value: channel.values[i] };
      }).filter(function (c) {
        return c.ts >= startTs && c.ts <= stopTs;
      });
    }

    return [];
  }

  setStartTime(dayStartMsUtc, recStartTs) {
    mc.router.refresh({ startTs: dayStartMsUtc });
  }

  help() {
    mc.ui.help(`./help/${rc.lang}/analytics_view.html`);
  }

  render() {
    let {
      subject,
      annotations,
      metrics = [],
      channels
    } = this.state;

    let startTs = parseInt(this.props.startTs);

    if (!subject) {
      return null;
    }

    let { channelStartTs, channelBreakTs, channelStopTs } = this.getBounds(startTs, subject.timezone);
    let metricPayload = metrics.find((m) => m.dayStartMsUtc === startTs);
    let errorTypes = metricPayload ? metricPayload.errorTypes : [];
    let todayMetrics = metricPayload ? metricPayload.metrics : {};
    let sleepSeries = this.getSeries("sleeping_posture", channelStartTs, channelStartTs + mc.math.MILLIS_PER_DAY);
    let postureSeries = this.getSeries("resting_posture", channelStartTs + (mc.math.MILLIS_PER_HOUR * 12), channelStopTs);
    let stepSeries = this.getSeries("steps", channelStartTs + (mc.math.MILLIS_PER_HOUR * 12), channelStopTs);

    return (
      <div className="rc-metric-detail-view" data-hidden={subject.isHidden}>
        <div className="mc-split-layout">
          <h1>
            <a href={mc.router.resolve("SUBJECT_DETAIL_VIEW", this.props)}>
              {subject.displayName || "..."}
            </a>
            {" › "}
            <a href={mc.router.resolve("METRIC_LIST_VIEW", this.props)}>
              {tx("analytics")}
            </a>
            {" › " + mc.format.date(startTs, "GMT", "long")}
            {errorTypes.length ? (
              <img src="./img/rc/bang.svg"/>
            ) : null}
          </h1>
          <div>
            <IconButton icon="help" onPress={this.help}/>
            <RecordingCalendar
              recordings={subject.recordings}
              ts={startTs}
              tz={"GMT"}
              onSelect={this.setStartTime.bind(this)}/>
          </div>
        </div>
        <div className="rc-metric-detail-view-summary mc-split-layout">
          <div>
            <h2>{tx("sleeping")}</h2>
            <MetricBrief category="SLEEPING" data={[todayMetrics.SLEEPING_DURATION]}/>
            <SleepChart series={sleepSeries} transitions={todayMetrics.SLEEPING_POSTURE_TRANSITIONS}/>
            <MetricBullet data={todayMetrics} keyAvg="SLEEPING_AVG_HR" keyMin="SLEEPING_MIN_HR" keyMax="SLEEPING_MAX_HR" unit="HR"/>
            <MetricBullet data={todayMetrics} keyAvg="SLEEPING_AVG_HRV" keyMin="SLEEPING_MIN_HRV" keyMax="SLEEPING_MAX_HRV" unit="HRV"/>
            <MetricBullet data={todayMetrics} keyAvg="SLEEPING_AVG_HRV_RMSSD" keyMin="SLEEPING_MIN_HRV_RMSSD" keyMax="SLEEPING_MAX_HRV_RMSSD" unit="HRV_RMSSD"/>
            <MetricBullet data={todayMetrics} keyAvg="SLEEPING_AVG_RESPIRATION" keyMin="SLEEPING_MIN_RESPIRATION" keyMax="SLEEPING_MAX_RESPIRATION" unit="RESPIRATION"/>
            <MetricBullet data={todayMetrics} keyAvg="SLEEPING_COMBINED_ACT_COUNT" unit="ACT_COUNT"/>
          </div>
          <div>
            <h2>{tx("resting")}</h2>
            <MetricBrief category="RESTING" data={[todayMetrics.RESTING_LYING_DURATION, todayMetrics.RESTING_SITTING_DURATION, todayMetrics.RESTING_STANDING_DURATION]}/>
            <PostureChart series={postureSeries}/>
            <MetricBullet data={todayMetrics} keyAvg="RESTING_AVG_HR" keyMin="RESTING_MIN_HR" keyMax="RESTING_MAX_HR" unit="HR"/>
            <MetricBullet data={todayMetrics} keyAvg="RESTING_AVG_HRV" keyMin="RESTING_MIN_HRV" keyMax="RESTING_MAX_HRV" unit="HRV"/>
            <MetricBullet data={todayMetrics} keyAvg="RESTING_AVG_HRV_RMSSD" keyMin="RESTING_MIN_HRV_RMSSD" keyMax="RESTING_MAX_HRV_RMSSD" unit="HRV_RMSSD"/>
            <MetricBullet data={todayMetrics} keyAvg="RESTING_COMBINED_ACT_COUNT" unit="ACT_COUNT"/>
          </div>
          <div>
            <h2>{tx("moving")}</h2>
            <MetricBrief category="MOVING" data={[todayMetrics.MOVING_WALKING_DURATION, todayMetrics.MOVING_OTHER_DURATION]}/>
            <StepChart
              series={stepSeries}
              startTs={channelStopTs - mc.math.MILLIS_PER_DAY}
              stepCount={todayMetrics.MOVING_STEPS}
              stepsPerMin={todayMetrics.MOVING_AVG_GAIT_CADENCE}/>
            <MetricBullet data={todayMetrics} keyAvg="MOVING_AVG_HR" keyMin="MOVING_MIN_HR" keyMax="MOVING_MAX_HR" unit="HR"/>
            <MetricBullet data={todayMetrics} keyAvg="MOVING_AVG_HRV" keyMin="MOVING_MIN_HRV" keyMax="MOVING_MAX_HRV" unit="HRV"/>
            <MetricBullet data={todayMetrics} keyAvg="MOVING_AVG_HRV_RMSSD" keyMin="MOVING_MIN_HRV_RMSSD" keyMax="MOVING_MAX_HRV_RMSSD" unit="HRV_RMSSD"/>
            <MetricBullet data={todayMetrics} keyAvg="MOVING_COMBINED_ACT_COUNT" unit="ACT_COUNT"/>
          </div>
        </div>
        <div className="rc-metric-detail-view-timeline">
          <MetricTimeline
            studyId={subject.studyId}
            timezone={subject.timezone}
            subjectId={subject.id}
            channels={channels}
            annotations={annotations}
            startTs={channelStartTs}
            breakTs={channelBreakTs}
            stopTs={channelStopTs}/>
        </div>
      </div>
    );
  }
}

module.exports = MetricDetailView;